export const testimonials = [
  {
    name: 'Dr. Elena Rodríguez',
    role: 'General Dentist',
    topic: 'Growth Assessment',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/61e8b44d-8b8b-4025-af76-5a0c14de37d0.jpg',
    quote:
      'The way the material connects craniofacial growth concepts with assessment frameworks is exactly the kind of organization I look for in a clinical study resource. The visual diagrams make it easier to review interconnected topics.',
  },
  {
    name: 'Dr. Marcus Bennett',
    role: 'Orthodontist',
    topic: 'Skeletal Maturity',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e53f1d48-c0cf-43d5-93d5-8ac2ddf9e717.jpg',
    quote:
      'I appreciate educational resources that explain not only skeletal maturity indicators, but also their limitations. Having those concepts organized in one place would make reviewing the subject much more practical.',
  },
  {
    name: 'Dr. Sofía Navarro',
    role: 'Orthodontic Resident',
    topic: 'Clinical Organization',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/71bc3159-4851-453c-a475-d06779111665.jpg',
    quote:
      'The diagnostic pathway is the part I find most interesting. Bringing facial assessment, skeletal relationships, and developmental findings together creates a useful framework for studying clinical cases.',
  },
  {
    name: 'Dr. Richard Hale',
    role: 'Pediatric Dentist',
    topic: 'Orthopedic Principles',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/5be3639f-463a-40d8-a258-ba2549ef2d54.jpg',
    quote:
      'A visual reference covering orthopedic appliance principles, treatment considerations, and growth patterns would be valuable for reviewing the fundamentals without jumping between multiple resources.',
  },
  {
    name: 'Dr. Laura Mitchell',
    role: 'General Dentist',
    topic: 'Practical Tools',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/00076a45-fa91-4383-9d04-212903ff1af5.jpg',
    quote:
      'The worksheets and assessment matrices make this concept especially appealing. They’re the type of supplementary material that can help organize educational case reviews and clinical observations.',
  },
  {
    name: 'Dr. Alejandro Vera',
    role: 'Dentist & Ortho Student',
    topic: 'Decision Trees',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/9dcea3ee-ab58-4365-9456-ecacfe945833.jpg',
    quote:
      'The educational decision trees are what caught my attention. Seeing when to observe, when to reassess, and when to consider referral laid out visually makes the whole subject far less intimidating to study.',
  },
];
